import React, { useEffect, useState } from "react";

import { RENT_REQUEST_TIMEOUT } from "../../../types/rentTypes";

import { formatDiffSecondToString, remainTime } from "../../../libs/dateFormat";

type Props = {
  status?: string;
  createdAt?: string;
  returnDueAt?: string;
  onLoad?: () => void;
};

export default function HistoryRemainTime({
  status,
  createdAt,
  returnDueAt,
  onLoad,
}: Props) {
  const [remainString, setRemainString] = useState("");
  const isLoadedRef = React.useRef(false);

  useEffect(() => {
    let timeInterval: NodeJS.Timeout;
    if (status === "REQUESTED") {
      timeInterval = setInterval(() => {
        if (remainTime(createdAt ?? "", RENT_REQUEST_TIMEOUT) > 0) {
          setRemainString(
            formatDiffSecondToString(
              remainTime(createdAt ?? "", RENT_REQUEST_TIMEOUT) ?? 0,
              { includesSeconds: true }
            )
          );
        } else {
          if (isLoadedRef.current) return;
          onLoad?.();
          isLoadedRef.current = true;
        }
      }, 1000);
    }

    if (status === "RENTED") {
      timeInterval = setInterval(() => {
        setRemainString(
          formatDiffSecondToString(
            Math.abs(remainTime(returnDueAt ?? "", 0) ?? 0)
          )
        );
      }, 1000);
    }
    return () => {
      clearInterval(timeInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return <span>{remainString}</span>;
}
